package org.catharsis.spendtel.core.navigation

import kotlinx.browser.window

actual fun consumeInitialPublicWebRoute(): String? {
    val path = window.location.pathname.removePrefix("/").removeSuffix("/")
    return when (path) {
        "privacy" -> AppRoutes.PrivacyPolicy.name
        "support" -> AppRoutes.ContactSupport.name
        "terms" -> AppRoutes.TermsAndConditions.name
        else -> null
    }
}
